import { Baby } from './profile';

export interface CreateOrderItemRequest {
  productId: number;
  productVariantId: number;
  quantity: number;
  unitPrice: number;
  totalPrice: number;
  isGift: boolean;
}

export interface CreateOrderPaymentMethodRequest {
  paymentMethod: number;
  amountPaid: number;
}

export interface CreateOrderRequest {
  customerId?: number;
  sellerId: number;
  status: number;
  channel: number;
  saleDate: string;
  observation?: string;
  items: CreateOrderItemRequest[];
  paymentMethods: CreateOrderPaymentMethodRequest[];
  guestName?: string;
  guestPhone?: string;
  guestStreet?: string;
  guestNumber?: string;
  guestNeighborhood?: string;
  guestCity?: string;
  guestState?: string;
  guestZipCode?: string;
  guestComplement?: string;
  guestEmail?: string;
  guestCpfCnpj?: string;
  guestBabies?: Baby[];
}

export enum PaymentMethod {
  CreditCard = 1,
  DebitCard = 2,
  Pix = 3,
  Cash = 4,
  CreditStore = 5,
  BankTransfer = 6,
  Promissory = 7,
}

export interface UpdateOrderItemRequest {
  id: number;
  productId: number;
  productVariantId: number;
  quantity: number;
  unitPrice: number;
  totalPrice: number;
}

export interface UpdateOrderPaymentMethodRequest {
  id: number;
  paymentMethod: number;
  amountPaid: number;
}

export interface UpdateStoreOrderRequest {
  observation?: string;
  items: UpdateOrderItemRequest[];
  paymentMethods: UpdateOrderPaymentMethodRequest[];
}

export const PaymentMethodLabel: Record<PaymentMethod, string> = {
  [PaymentMethod.CreditCard]: 'Cartão de Crédito',
  [PaymentMethod.DebitCard]: 'Cartão de Débito',
  [PaymentMethod.Pix]: 'Pix',
  [PaymentMethod.Cash]: 'Dinheiro',
  [PaymentMethod.CreditStore]: 'Crédito em Loja',
  [PaymentMethod.BankTransfer]: 'Transferência Bancária',
  [PaymentMethod.Promissory]: 'Promissória',
};
